import { addHours } from 'date-fns';

import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { START_DATE } from 'mocks/server/utils/constants';

export const demandHistory: HealthMetricsHistory[] = [
  {
    date: START_DATE.getTime(),
    value: 11,
  },
  {
    date: addHours(START_DATE, 1).getTime(),
    value: 20,
  },
  {
    date: addHours(START_DATE, 2).getTime(),
    value: 25,
  },
  {
    date: addHours(START_DATE, 3).getTime(),
    value: 26,
  },
  {
    date: addHours(START_DATE, 4).getTime(),
    value: 28,
  },
  {
    date: addHours(START_DATE, 5).getTime(),
    value: 15,
  },
  {
    date: addHours(START_DATE, 6).getTime(),
    value: 33,
  },
  {
    date: addHours(START_DATE, 7).getTime(),
    value: 35,
  },
  {
    date: addHours(START_DATE, 8).getTime(),
    value: 36,
  },
  {
    date: addHours(START_DATE, 9).getTime(),
    value: 40,
  },
  {
    date: addHours(START_DATE, 10).getTime(),
    value: 51,
  },
  {
    date: addHours(START_DATE, 11).getTime(),
    value: 34,
  },
  {
    date: addHours(START_DATE, 12).getTime(),
    value: 40,
  },
  {
    date: addHours(START_DATE, 13).getTime(),
    value: 34,
  },
  {
    date: addHours(START_DATE, 14).getTime(),
    value: 35,
  },
  {
    date: addHours(START_DATE, 15).getTime(),
    value: 38,
  },
  {
    date: addHours(START_DATE, 16).getTime(),
    value: 40,
  },
  {
    date: addHours(START_DATE, 17).getTime(),
    value: 34,
  },
  {
    date: addHours(START_DATE, 18).getTime(),
    value: 36,
  },
  {
    date: addHours(START_DATE, 19).getTime(),
    value: 38,
  },
  {
    date: addHours(START_DATE, 20).getTime(),
    value: 40,
  },
  {
    date: addHours(START_DATE, 21).getTime(),
    value: 24,
  },
  {
    date: addHours(START_DATE, 22).getTime(),
    value: 20,
  },
];
